import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';

@Component({
  selector: 'app-step7-data',
  templateUrl: './step7-data.component.html',
  styleUrls: ['./step7-data.component.scss']
})
export class Step7DataComponent implements OnInit {
  dataId : any ;
 
    
  
  dataStep7_inf = [
    {
      position: 71, 
      tittle: '7.1 La identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional deberán realizarse de conformidad con lo siguiente:', 
      subInd : [
        {
          info: "a) Los centros de trabajo que tengan entre 16 y 50 trabajadores, únicamente deberán realizar la identificación y análisis de los factores de riesgo psicosocial, incluyendo a todos los trabajadores (ver Guía de referencia II), y ", 
          ruta : './step7-sub1-a%29'
        },{
          info: "b) Los centros de trabajo que tengan más de 50 trabajadores, deberán realizar la identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional, éstas se podrán realizar con una muestra representativa conforme a lo señalado en la Guía de referencia III, en el numeral III",
          ruta : './step7-sub1-b%29'
        }
      ],

    },{
      position: 72,
      tittle: '7.2 La identificación y análisis de los factores de riesgo psicosocial deberá contemplar lo siguiente:',
      subInd : [
        {
          info: 'a) Las condiciones en el ambiente de trabajo. Se refieren a condiciones peligrosas e inseguras o deficientes e insalubres; es decir, a las condiciones del lugar de trabajo, que bajo ciertas circunstancias exigen del trabajador un esfuerzo adicional de adaptación;',
          ruta:'./step7-sub2-a%29'
        },{
          info: 'b) Las cargas de trabajo. Se refieren a las exigencias que el trabajo impone al trabajador y que exceden su capacidad, pueden ser de diversa naturaleza, como cuantitativas, cognitivas o mentales, emocionales, de responsabilidad, así como cargas contradictorias o inconsistentes;',
          ruta:'./step7-sub2-b29'
        },{
          info: "c) La falta de control sobre el trabajo. El control sobre el trabajo es la posibilidad que tiene el trabajador para influir y tomar decisiones en la realización de sus actividades. La iniciativa y autonomía, el uso y desarrollo de habilidades y conocimientos, la participación y manejo del cambio, así como la capacitación son aspectos que dan al trabajador la posibilidad de influir sobre su trabajo. Estos elementos, cuando son inexistentes o escasos, se convierten en un factor de riesgo.",
          ruta:'./step7-sub2-c%29'
        },{
          info: "d) Las jornadas de trabajo y rotación de turnos que exceden lo establecido en la Ley Federal del Trabajo. Representan una exigencia de tiempo laboral que se hace al trabajador en términos de la duración y el horario de la jornada, se convierte en factor de riesgo psicosocial cuando se trabaja con extensas jornadas, con frecuente rotación de turnos o turnos nocturnos, sin pausas y descansos periódicos claramente establecidos y ni medidas de prevención y protección del trabajador para detectar afectación de su salud, de manera temprana;",
          ruta:'./step7-sub2-d%29'
        },{
          info: "e) Interferencia en la relación trabajo-familia. Surge cuando existe conflicto entre las actividades familiares o personales y las responsabilidades laborales; es decir, cuando de manera constante se tienen que atender responsabilidades laborales durante el tiempo dedicado a la vida familiar y personal, o se tiene que laborar fuera del horario de trabajo;",
          ruta:'./step7-sub2-e%29'
        },{
          info: "f) Liderazgo negativo y relaciones negativas en el trabajo:",
          ruta:'./step7-sub2-f%29'
        },{
          info: "g) La violencia laboral, de conformidad con lo siguiente:",
          ruta:'./step7-sub2-g%29'
        }
      ],
      
    },
    {
      position: 73,
      tittle: '7.3 La evaluación del entorno organizacional favorable deberá comprender:',
      subInd : [ 
        {
          info: 'a) El sentido de pertenencia de los trabajadores a la empresa;',
          ruta : './step7-sub3-a%29'
        },{ 
          info: 'b) La formación para la adecuada realización de las tareas encomendadas',
          ruta : './step7-sub3-b%29'
        },{
          info: "c) La definición precisa de responsabilidades para los trabajadores;",
          ruta : './step7-sub3-c%29'
        },{
          info: "d) La participación proactiva y comunicación entre el patrón, sus representantes y los trabajadores;",
          ruta : './step7-sub3-d%29'
        },{
          info: "e) La distribución adecuada de cargas de trabajo, con jornadas laborales regulares, y",
        ruta : './step7-sub3-e%29'
        },{
          info: "f) La evaluación y el reconocimiento del desempeño.",
          ruta : './step7-sub3-f%29'
        }
      ],
      
 
    },
    {
      position: 74,
      tittle: '7.4 Los centros de trabajo podrán utilizar para identificar y analizar los factores de riesgo psicosocial y evaluar el entorno organizacional, cualquier método que contemple lo siguiente:',
      subInd : [ 
        {
          info: 'a) La aplicación de cuestionarios que cumplan con lo dispuesto por los numerales 7.2 y/o 7.3, según corresponda, y 7.5 de la presente Norma;',
          ruta : './step7-sub4-a%29'
        },{
          info: 'b) La forma como se deberá realizar la aplicación de los cuestionarios;',
          ruta : './step7-sub4-b%29'
        },{
          infoC: "c) La manera de evaluar los cuestionarios, y",
          ruta : './step7-sub4-c%29'
        },{
          infoD: "d) Los niveles de riesgo y la forma de determinarlos conforme a los resultados de los cuestionarios.",
          ruta : './step7-sub4-d%29'
        }
      ],
     
    }
    
  ]

  
  constructor(private activated: ActivatedRoute) {
  }

  ngOnInit() {
    this.activated.data.subscribe  (params=>{this.dataId = params});
  console.log(this.dataId);
  }

}
